import { connect } from 'react-redux';

import SelectGlobalSchool from '../components/SelectGlobalSchool';

import { selectClassroom } from '../actions/classrooms';
import { fetchSchools, selectSchool } from '../actions/schools';
import { selectStudent } from '../actions/students';

// const getSchoolsFromSelectedDistrict = (state) => {
// 	if (state.schools.list &&
// 		state.districts.selected) {
// 		state.schools.list.filter((school) => school.district_id === state.districts.selected.id);
// 	}
// };

const mapStateToProps = (state) => {
	return {
		isFetchingDistrict: state.districts.isFetching,
		isFetchingSchools: state.schools.isFetching,
		schools: state.schools.list,
		selectedDistrict: state.districts.selected,
		selectedSchool: state.schools.selected
	};
};

const mapDispatchToProps = {
	fetchSchools,
	selectClassroom,
	selectSchool,
	selectStudent
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectGlobalSchool);



// WEBPACK FOOTER //
// ./frontend/a2i/js/containers/SelectGlobalSchool.jsx